import React from 'react';
import { useParams } from 'react-router-dom';
import PublicCmsPage from './PublicCmsPage';

const PublicCmsRoute = () => {
  const { slug } = useParams();
  return <PublicCmsPage slug={slug || 'home'} />;
};

export default PublicCmsRoute;
